import api from '../../services/api';
import { toast } from 'react-toastify';
import i18n from '../../utils/i18n.ts';

export const fetchTopics = async () => {
  const response = await api.get(`/topics?showInactive=false`);

  if (!response) {
    toast.error(i18n.t('error.api.get-list', { item: i18n.t('module.topics') }));
  }

  return response.data;
};

export const fetchTopicById = async (id: number | string | undefined | null) => {
  const response = await api.get(`/topics/${id}`);
  if (!response) {
    toast.error(i18n.t('error.api.get-item', { item: i18n.t('module.topic') }));
  }
  return response.data;
};

export const createTopic = async (data: unknown) => {
  const response = await api.post(`/topics`, data);
  if (!response) {
    toast.error(i18n.t('error.api.post-item', { item: i18n.t('module.topic') }));
  }
  return response.data;
};

export const updateTopic = async ({ data }: { data: unknown }) => {
  const response = await api.put(`/topics`, data);

  if (!response) {
    toast.error(i18n.t('error.api.put-item', { item: i18n.t('module.topic') }));
  }

  return true;
};

export const deleteTopic = async (params: { ids: string[] }) => {
  const response = await api.delete(`/topics`, { data: params });
  if (!response) {
    toast.error(i18n.t('error.api.delete-item', { item: i18n.t('module.topic') }));
  }
  return true;
};
